'use strict';

import * as material from './material';
import { Form } from './form';
import $ from 'jquery';

material.initialize();

$('form.Plugin--Form').each((key, formElement) => {
  new Form(formElement);
});
